import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/monitoring-studies")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/monitoring-studies", statusCode: 301 }); },
});
